import React, { useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import PortfolioTypeBusiness from "./PortfolioType";

const Portfolio = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const { state } = useLocation();

  const current = state?.current;
  const currency = state?.currency;

  const navigate = useNavigate();

  useEffect(() => {
    if (!current || !currency) {
      navigate(-1);
    }
  }, []);

  return current ? (
    <PortfolioTypeBusiness
      type={current}
      _currency={currency}
      back={() => {
        navigate(-1);
      }}
    />
  ) : (
    <></>
  );
};

export default Portfolio;
